<template>
  <div class="big">
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <!-- 选择商品 -->
        <ChooseGood
          v-if="chooseGoodShow"
          @close="chooseGoodShow = false"
          @checkGoods="checkGoods"
        ></ChooseGood>
        <div>
          <span>商品名称</span>
          <el-input
            v-model="goods_keyword"
            style="width:200px;margin:0 15px 0 8px"
            @change="search"
          ></el-input>
          <span>科室</span>
          <el-input
            v-model="keyword_name"
            style="width:200px;margin:0 15px 0 8px"
            @change="search"
          ></el-input>
          <el-button
            type="info"
            style="background-color:#eceff2;;color:#747981;"
            @click="search"
          >查询</el-button>
        </div>
        <div class="topbpx">
          <el-button
            type="primary"
            style="width:120px"
            @click="addDia"
            :disabled="
            module_id_array[0] ? !module_id_array.includes('898') : false
          "
          >添加科室</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            :span-method="objectSpanMethod"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="关键词"
              width="300"
              align="center"
              class-name="border-column"
            >
              <template slot-scope="
              scope">
                <div style="text-align:center">
                  <div style="margin-bottom:10px">{{scope.row.keyword_name}}</div>
                  <div>
                    <el-button
                      type="primary"
                      plain
                      @click="addGoods(scope.row.keyword_id)"
                      :disabled="
            module_id_array[0] ? !module_id_array.includes('896') : false
          "
                    >选择商品</el-button>
                  </div>
                  <div>
                    <el-button
                      type="text"
                      style="width:120px"
                      @click="delKeyword(scope.row.keyword_id)"
                      :disabled="
            module_id_array[0] ? !module_id_array.includes('897') : false
          "
                    >删除科室</el-button>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="排序"
              width="100"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.sort"
                  step-strictly
                  :step="1"
                  :min="0"
                  :max="9999999999"
                  :controls="false"
                  style="width:80px"
                  @change="setSort(scope.row.recommend_goods_id,scope.row.sort)"
                  :disabled="module_id_array[0]?!module_id_array.includes('379'):false"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              label="商品"
              width="300"
            >
              <template slot-scope="scope">
                <div class="flex align-center">
                  <img
                    :src="scope.row.picture"
                    alt
                    style="width: 80px; height: auto; margin-right: 15px"
                  />
                  <div>
                    <div>{{ scope.row.goods_name }}</div>
                    <div
                      class="outstate"
                      v-if="scope.row.state==1||scope.row.state==10||scope.row.state==5||scope.row.state==6"
                    >
                      已下架
                    </div>
                  </div>

                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="规格"
              prop="sku_name"
            >
            </el-table-column>
            <el-table-column
              label="商品价格"
              prop="new_price"
            >
            </el-table-column>
            <el-table-column
              label="活动价"
              prop="activity_price"
            >
              <template slot-scope="scope">
                <div>{{scope.row.activity_price?scope.row.activity_price:"无"}}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="销量"
              prop="real_sales"
            >
            </el-table-column>
            <el-table-column
              label="库存"
              prop="stock"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              width="100"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.goods_id"
                  type="text"
                  size="medium"
                  @click="delGoods(scope.row.recommend_goods_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('895')
                      : false
                  "
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align:center;margin-top:20px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="添加科室"
      :visible.sync="good_at_dia"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="text-align:left;padding:20px">

        <el-select
          v-model="add_keyword_name"
          filterable
          placeholder="请选择或输入"
        >
          <el-option
            v-for="item in department_list"
            :key="item.department_id"
            :label="item.department_name"
            :value="item.department_name"
          >
          </el-option>
        </el-select>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="good_at_dia=false"
          size="medium"
          plain
        >取 消</el-button>
        <el-button
          type="primary"
          size="medium"
          @click="addKeyWords"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ChooseGood from './ChooseGood';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      goods_keyword: '',
      keyword_name: '',
      tableData: [],
      chooseGoodShow: false,
      goods_list: [],
      keyword_id: '',
      department_list: [],
      good_at_dia: false,
      add_keyword_name: ''
    };
  },
  components: {
    ChooseGood
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    getList() {
      let data = {
        goods_keyword: this.goods_keyword,
        keyword_name: this.keyword_name,
        recommend_id: 4,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      this.axios
        .post('platform/shop/getKeyWordGoodsLists', data)
        .then((res) => {
          this.fomartList(res.data.list);
          this.totalNum = res.data.total;
        })
        .catch((err) => {});
    },
    //格式化列表
    fomartList(list) {
      let arr = [];
      list.forEach((ele) => {
        if (ele.item.length > 0) {
          ele.item.forEach((goods, index) => {
            let obj = {
              keyword_id: ele.keyword_id,
              keyword_name: ele.keyword_name,
              recommend_id: ele.recommend_id,
              goods_id: goods.goods_id,
              goods_name: goods.goods_name,
              picture: goods.picture,
              recommend_goods_id: goods.recommend_goods_id,
              sort: goods.sort,
              state: goods.state,
              stock: goods.stock,
              sku_name: goods.sku_name,
              new_price: goods.new_price,
              activity_price: goods.activity_price,
              real_sales: goods.real_sales
            };
            arr.push(obj);
          });
        } else {
          ele.goods_id = '';
          ele.goods_name = '';
          ele.picture = '';
          ele.recommend_goods_id = '';
          ele.sort = '';
          ele.state = '';
          arr.push(ele);
        }
      });
      this.tableData = arr;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let num = 0;
      if (columnIndex == 0) {
        this.tableData.forEach((ele) => {
          if (row.keyword_id == ele.keyword_id) {
            num++;
          }
        });
      }
      if (num == 1) {
        return {
          rowspan: 1,
          colspan: 1
        };
      } else if (num > 1) {
        if (
          this.tableData[rowIndex - 1] &&
          this.tableData[rowIndex].keyword_id ==
            this.tableData[rowIndex - 1].keyword_id
        ) {
          return {
            rowspan: 0,
            colspan: 0
          };
        } else {
          return {
            rowspan: num,
            colspan: 1
          };
        }
      }
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //获取科室列表
    getDepartment() {
      this.axios.post('platform/photograph/getDepartmentList').then((res) => {
        this.department_list = res.data.list;
      });
    },
    //修改排序
    setSort(recommend_goods_id, sort) {
      let data = {
        recommend_goods_id,
        sort
      };
      this.axios
        .post('platform/shop/saveRecommendGoodsSort', data)
        .then((res) => {
          this.$message.success('修改成功');
          this.getList();
        })
        .catch((err) => {
          this.getList();
        });
    },
    //添加商品弹窗
    addGoods(keyword_id) {
      this.keyword_id = keyword_id;
      this.chooseGoodShow = true;
    },
    //选择商品
    checkGoods(goods) {
      let goods_arr = goods.map((item) => {
        return item.goods_id;
      });
      let data = {
        recommend_id: 4,
        keyword_id: this.keyword_id,
        goods_ids: goods_arr.toString()
      };
      this.axios
        .post('platform/shop/addRecommendGoods', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('商品添加成功');
            this.getList();
            this.chooseGoodShow = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.getList();
        });
    },
    //删除商品
    delGoods(recommend_goods_id) {
      this.$confirm('确定删除该商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/shop/delRecommendGoods', { recommend_goods_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('商品已删除');
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //添加弹窗
    addDia() {
      this.add_keyword_name = '';
      this.good_at_dia = true;
    },
    //添加关键词
    addKeyWords() {
      if (!this.add_keyword_name) {
        this.$message.error('请选择或输入科室');
        return false;
      }
      let data = {
        recommend_id: 4,
        keyword_name: this.add_keyword_name
      };
      this.axios.post('platform/shop/addKeyword', data).then((res) => {
        if (res.code == 0) {
          this.$message.success('科室已添加');
          this.good_at_dia = false;
          this.getList();
        }
      });
    },
    //删除关键字
    delKeyword(keyword_id) {
      this.$confirm('确定删除该科室吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/shop/delKeyword', { keyword_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('科室已删除');
                this.getList();
              }
            });
        })
        .catch(() => {});
    }
  },
  created() {
    this.getList();
    this.getDepartment();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  text-align: left;
}
.topbpx {
  display: flex;
  align-items: flex-end;
  margin: 20px 0;
}
.title {
  font-size: 18px;
  font-weight: 700;
  margin-left: 20px;
}
.outstate {
  text-align: center;
  width: 60px;
  color: #ff7430;
  border: 2px solid #ff7430;
  border-radius: 3px;
  font-weight: 700;
}
.border_right {
  border-right: 1px solid #333;
}
</style>
<style lang="scss">
.border-column {
  border-right: 1px solid #ebeef5;
}
</style>
